module.exports = __webpack_public_path__ + "img/logo_bw_mr.2a785e69.svg";